export enum DamageLocalStorage {
  KEY = 'damageFilterKey',
  STATUS = 'damageFilterStatus',
}
